import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import {
    GuestFreeUsageApi,
    type GuestFreeUsageApi as GuestFreeUsageApiType,
} from '../../apis/guest-free-usage-api';
import type { GuestFreeUsageService } from '../guest-free-usage-service';

/**
 * 游客免费使用资格 service。
 *
 * 作为业务编排层与后端 API 之间的稳定抽象，避免各 onboarding 模块直接依赖 HTTP 实现。
 */
@injectable()
export class GuestFreeUsageServiceImpl implements GuestFreeUsageService {
    constructor(
        /** 提供后端游客免费使用资格查询能力。 */
        @inject(GuestFreeUsageApi)
        private readonly _guestFreeUsageApi: GuestFreeUsageApiType,
    ) {}

    /**
     * 查询当前用户是否可免费执行一次指定 AI 任务。
     * @param taskType 后端定义的统一 AI 任务类型。
     */
    canUseOnce(taskType: string): Promise<boolean> {
        return this._guestFreeUsageApi.canUseOnce(taskType);
    }
}
